import * as React from 'react';
import { Col, Row } from 'react-bootstrap';
import NcwProductButton from './NcwProductButton/NcwProductButton';
import PromoBox from './PromoBox/PromoBox';
import { BrandInterface } from '../../../../../Interface/Brand';
import { ProductSizeInterface } from '../../../../../Interface/ProductSize';
import ShippingInfo from '../../../ShippingInfo/ShippingInfo';
import { getProductSizeDiscountDisplay } from '../../../../Helper/flavourDiscount';
import clsx from 'clsx';
import styles from './ProductNameRow.module.scss?module';

/**
 * PID-Störer (P-4877). Zeigt genau eine der beiden Kommunikationen, je nach der
 * zentralen Entscheidung in getProductSizeDiscountDisplay:
 * - kind === 'promotion' → Promo-Text (Discount- oder Plus-Promo), wie bei jedem
 *   Promo-Produkt. Die Clearance-Info steht dann pro Flavour.
 * - kind === 'clearance' → Clearance-Aggregat "X% Off" bzw. "Up to X% Off".
 */
export default function ProductNameRow({
  brand,
  product_size,
}: {
  brand?: BrandInterface;
  product_size: ProductSizeInterface;
}) {
  const _brand = product_size?.brand ?? brand;
  const display = React.useMemo(
    () => getProductSizeDiscountDisplay(product_size),
    [product_size]
  );

  return (
    <Row className="mb-3">
      <Col lg={6}>
        <div className={clsx(styles.ProductName, 'mb-0')}>
          {product_size.name}
        </div>
        <div className="pt-1">
          <div className={styles.Brand}>{_brand?.name}</div>
          <div className="pt-2">
            <ShippingInfo
              unitsPerCase={product_size.vpe}
              unitsPerPallet={product_size.units_per_pallet}
            />
          </div>
        </div>
      </Col>
      <Col lg={6} className="pt-3 pt-lg-0">
        <div className="d-none d-lg-block mb-3">
          <NcwProductButton product_size={product_size} />
        </div>
        {display.kind === 'clearance' && display.clearanceLabel ? (
          <PromoBox text={display.clearanceLabel} availableShortly={false} />
        ) : display.kind === 'promotion' && display.promoText ? (
          <PromoBox
            text={display.promoText}
            availableShortly={!!product_size.has_available_shortly_promo}
          />
        ) : null}
      </Col>
    </Row>
  );
}
